import { observer } from "mobx-react-lite";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

import { Description } from "@/components/Description";
import { SkipButton } from "@/components/dialog/create-team/SkipButton";
import { Invites } from "@/components/dialog/team/members/Invites";
import { FormButton } from "@/components/form/FormButton";
import { Title } from "@/components/Title";
import { useStore } from "@/store";

export const StepInvites = observer(function StepInvites() {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;
  const t = useTranslations();
  const router = useRouter();

  const { team } = createTeamDialog;

  if (!team) {
    return null;
  }

  const handleButtonClick = () => {
    createTeamDialog.close();
    router.push(`/${team.permalink}`);
  };

  return (
    <>
      <Title value={t("createTeamDialog.stepInvites.title", { team: team.title })} />
      <Description value={t("createTeamDialog.stepInvites.description")} />
      <Invites team={team} context="create-team-dialog" />
      {team.invitesUX.invites.length > 0 ? (
        <FormButton
          variant="accent"
          size="sm"
          type="submit"
          className="w-full mt-2.5"
          onClick={handleButtonClick}
        >
          {t("createTeamDialog.doneButton")}
        </FormButton>
      ) : (
        <SkipButton onClick={handleButtonClick} />
      )}
    </>
  );
});
